import { User } from './user.model';

export class UserResponse {
  userList: User[];
  total: number;

  constructor(userList: any, total: number) {
    this.userList = userList;
    this.total = total;
  }
}
